/* eslint-disable */
import { api } from './../../api.js';
import {vue_instance} from "../../main";
//import api_routes from './../../api_routes.js';

const state = {
};

const getters = {

}

const mutations = {
}

const actions = {
    editNotification: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('notifications/' + data.id , data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getNotification : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('notifications/' + data.id , data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getNotifications : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('notifications', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
}

export default {
    state,
    actions,
    getters,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/NotificationsModule.js